export const generateUniqueId = (prefix = "id") => {
    const id = Math.random().toString(36).substring(2, 10).padEnd(8, "0");
    return `${prefix}-${id}`;
};
